import * as React from 'react'

const Close = (props: { className?: string }) => (
  <svg
    className={props.className}
    width='6'
    height='6'
    viewBox='0 0 6 6'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M3.81301 2.89459L5.92683 0.77027C6.02439 0.672973 6.02439 0.527027 5.92683 0.42973L5.60163 0.0891892C5.50407 -0.00810811 5.35772 -0.00810811 5.26016 0.0891892L3.13008 2.21351C3.06504 2.27838 2.96748 2.27838 2.90244 2.21351L0.772358 0.072973C0.674797 -0.0243243 0.528455 -0.0243243 0.430894 0.072973L0.0894309 0.413514C-0.00813008 0.510811 -0.00813008 0.656757 0.0894309 0.754054L2.21951 2.87838C2.28455 2.94324 2.28455 3.04054 2.21951 3.10541L0.0731707 5.24595C-0.0243902 5.34324 -0.0243902 5.48919 0.0731707 5.58649L0.414634 5.92703C0.512195 6.02432 0.658537 6.02432 0.756098 5.92703L2.88618 3.8027C2.95122 3.73784 3.04878 3.73784 3.11382 3.8027L5.2439 5.92703C5.34146 6.02432 5.4878 6.02432 5.58537 5.92703L5.92683 5.58649C6.02439 5.48919 6.02439 5.34324 5.92683 5.24595L3.81301 3.12162C3.74797 3.05676 3.74797 2.95946 3.81301 2.89459Z'
      fill='#8C97A2'
    />
  </svg>
)

export default Close



// WEBPACK FOOTER //
// ./src/components/icons/vehicle/Close.tsx